import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { LinearProgress } from "@mui/material";
import Grid from "@material-ui/core/Grid";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import { capitalizeFirstLetter } from "../../../../../../utils/mask";


const ModalDevolutiva = ({open, onClose, data}) => {
    
    const {temas, classificacao, percentualGeral } = data;
    
    const valorPercentual = Math.ceil(percentualGeral);
    
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 700,
        bgcolor: 'background.paper',
        borderRadius: '20px',
        p: 4,
    };
    
    const rootStyle = {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
    };
    
    const progressTextStyle = {
        marginRight: '8px',
    };
    
    const colorClassificacao = {
        'AVANCADO': '#0DBABA',
        'BASICO': '#CD5BE8',
        'INTERMEDIARIO': '#666BFD'
    }
    
    const colorStatus = {
        'Avançado': '#0DBABA',
        'Intermediário': '#CD5BE8',
        'Básico': '#666BFD'
    }
    
    
    const ProgressBar = ({tema}) => {
        
        const linearProgressStyle = {
            '& .MuiLinearProgress-bar': {
                backgroundColor: colorStatus[tema.tipo]
            }
        };
        
        return (
            <Grid container alignItems={"center"} sx={{px: 8}}>
                <Typography color={'#28293D'}
                            style={{fontWeight: 'bold'}}>{tema.titulo}</Typography>
                <Grid container alignItems="center" style={rootStyle}>
                    <Grid item style={progressTextStyle}>
                        <Typography variant="body1">{`${tema.percentual}%`}</Typography>
                    </Grid>
                    <Grid item xs>
                        <LinearProgress sx={linearProgressStyle}
                                        style={{height: 8, borderRadius: '2px', backgroundColor: '#EBEBF0'}}
                                        variant="determinate" value={tema.percentual}/>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
    
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2" mb={4}>
                    Devolutiva do diagnóstico
                </Typography>
                
                <Grid container direction="column" justifyContent="center" alignItems="center">
                    <Typography component="h4">
                        Nível
                    </Typography>
                    
                    <Typography component="h5" color={colorClassificacao[classificacao]} sx={{fontWeight: 'bold'}} mb={1}>
                        {capitalizeFirstLetter(classificacao)}
                    </Typography>
                    
                    <div style={{width: 170, height: 170}}>
                        <CircularProgressbar value={valorPercentual} text={`${valorPercentual}%`}
                                             styles={buildStyles({
                                                 strokeLinecap: 'butt',
                                                 pathColor: colorClassificacao[classificacao],
                                                 textColor: '#28293D',
                                                 textSize: '26px',
                                                 trailColor: "#EBEBF0",
                                                 backgroundColor: 'transparent'
                                             })}
                        />
                    </div>
                </Grid>
                <div style={{marginTop: '6px'}}>
                    {temas?.map((tema, index) => <ProgressBar key={index} tema={tema} />)}
                </div>
            </Box>
        </Modal>
    );
};

export default ModalDevolutiva;
